import React, { useState } from 'react'
import { useNavigate, Link } from 'react-router-dom'
import api from '../api'

export default function ForgotPassword() {
  const navigate = useNavigate()
  const [email, setEmail] = useState('')
  const [loading, setLoading] = useState(false)
  const [sent, setSent] = useState(false)
  const [error, setError] = useState('')

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault()
    if (loading) return

    setError('')
    setLoading(true)

    try {
      await api.post('/auth/forgot-password', { email })
      setSent(true)
    } catch (err: any) {
      setError(err?.response?.data?.error || 'Something went wrong')
    } finally {
      setLoading(false)
    }
  }

  return (
    <div style={{
      minHeight: '100vh', background: 'var(--cream)',
      display: 'flex', alignItems: 'center',
      justifyContent: 'center', padding: '24px',
    }}>
      <div style={{ width: '100%', maxWidth: '420px' }}>

        <div
          onClick={() => navigate('/')}
          style={{
            fontFamily: 'var(--font-display)', fontSize: '28px',
            fontWeight: 700, color: 'var(--navy)',
            textAlign: 'center', marginBottom: '40px', cursor: 'pointer',
          }}
        >
          Velu<span style={{ color: 'var(--gold)' }}>mio</span>
        </div>

        <div style={{
          background: 'var(--white)', borderRadius: 'var(--radius-lg)',
          padding: '40px', boxShadow: 'var(--shadow-md)',
          border: '1px solid var(--cream-dark)',
        }}>

          {sent ? (
            <div style={{ textAlign: 'center' }}>
              <div style={{ fontSize: '56px', marginBottom: '20px' }}>📬</div>
              <h2 style={{
                fontFamily: 'var(--font-display)', fontSize: '22px',
                color: 'var(--navy)', marginBottom: '12px',
              }}>
                Check your inbox
              </h2>
              <p style={{
                fontSize: '14px', color: 'var(--muted)',
                lineHeight: 1.7, marginBottom: '24px',
              }}>
                If an account exists with <strong>{email}</strong>, a password reset link has been sent. Check your spam folder if you don't see it within a few minutes.
              </p>
              <button
                onClick={() => navigate('/login')}
                style={{
                  padding: '12px 32px', fontSize: '15px',
                  fontWeight: 600, color: 'var(--white)',
                  background: 'var(--navy)', border: 'none',
                  borderRadius: 'var(--radius-full)',
                  cursor: 'pointer', fontFamily: 'var(--font-body)',
                }}
              >
                Back to login
              </button>
            </div>
          ) : (
            <>
              <h2 style={{
                fontFamily: 'var(--font-display)', fontSize: '24px',
                marginBottom: '8px', color: 'var(--navy)',
              }}>
                Forgot your password?
              </h2>
              <p style={{
                fontSize: '14px', color: 'var(--muted)', marginBottom: '32px',
              }}>
                Enter your email address and we will send you a reset link.
              </p>

              <form onSubmit={handleSubmit}>
                <div style={{ marginBottom: '24px' }}>
                  <label style={{
                    display: 'block', fontSize: '13px',
                    fontWeight: 600, color: 'var(--ink)', marginBottom: '8px',
                  }}>
                    Email address
                  </label>
                  <input
                    type="email"
                    value={email}
                    onChange={e => setEmail(e.target.value)}
                    placeholder="you@example.com"
                    required
                    autoComplete="email"
                    style={{
                      width: '100%', padding: '12px 14px', fontSize: '14px',
                      border: '1.5px solid var(--warm-border)',
                      borderRadius: 'var(--radius-md)', outline: 'none',
                      fontFamily: 'var(--font-body)', color: 'var(--ink)',
                      background: 'var(--cream)', boxSizing: 'border-box' as const,
                    }}
                    onFocus={e => { e.currentTarget.style.borderColor = 'var(--gold)' }}
                    onBlur={e => { e.currentTarget.style.borderColor = 'var(--warm-border)' }}
                  />
                </div>

                {error && (
                  <div style={{
                    padding: '12px 14px', background: 'var(--rose-light)',
                    borderRadius: 'var(--radius-md)', fontSize: '13px',
                    color: 'var(--rose)', marginBottom: '20px',
                  }}>
                    {error}
                  </div>
                )}

                <button
                  type="submit"
                  disabled={loading || !email}
                  style={{
                    width: '100%', padding: '14px', fontSize: '16px',
                    fontWeight: 600, color: 'var(--white)',
                    background: loading || !email ? 'var(--muted)' : 'var(--navy)',
                    border: 'none', borderRadius: 'var(--radius-md)',
                    cursor: loading || !email ? 'not-allowed' : 'pointer',
                    fontFamily: 'var(--font-body)',
                  }}
                >
                  {loading ? 'Sending...' : 'Send reset link'}
                </button>
              </form>
            </>
          )}
        </div>

        <p style={{
          textAlign: 'center', marginTop: '24px',
          fontSize: '14px', color: 'var(--muted)',
        }}>
          <Link to="/login" style={{ color: 'var(--gold)', fontWeight: 500 }}>
            Back to login
          </Link>
        </p>

      </div>
    </div>
  )
}